import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from "actions/Ticket";
import { ThemMoiGoiVay } from "./ThemMoiGoiVay";
export const AddGoiVayBtn = (data, onSearch) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);

  }
  return (
    <div className="hide-table-main show-mobile-main hidden-des-main">
     <div className="row">
        <div className="col-sm-12 col-md-9">
          <button
            type="button"
            className="btn btn-border-new"
            onClick={handleShow}
          >
            <i className="mdi mdi-plus"></i> Thêm mới
          </button>
        </div>
     
        {show && <ThemMoiGoiVay data={data} show={show} onHide={handleClose} />}
      </div>
    </div>
  );
};
